export default [
  // PRIVATE
  {
    path: '/profile/two-factor',
    name: 'profileTwoFactor',
    component: () => import('@/pages/profile/ProfileTwoFactor'),
    meta: {
      requiresAuth: true,
    },
  },
  // PUBLIC
  {
    path: '/two-factor/:result?',
    name: 'TwoFactorAuth',
    component: () => import('@/pages/2fa/TwoFactorAuth'),
    props: true,
  },
];
